// Landing pages ciblant les mots-clés spécifiques
export const USE_CASES = [
  {
    slug: "planning-renovation",
    h1: "Planning de rénovation : générez-le en 60 secondes",
    metaTitle: "Planning de rénovation appartement / maison — Gratuit",
    metaDescription:
      "Créez un planning de rénovation détaillé en 60 secondes à partir de vos devis : tâches ordonnées, corps d'état, chemin critique. Beta gratuite.",
    keywords: "planning rénovation, planning travaux rénovation, planning appartement, planning maison ancienne",
    heroPunch: "De la démolition aux finitions, votre planning complet, prêt à envoyer aux entreprises.",
    intro:
      "Une rénovation, c'est 8 à 15 lots qui doivent s'enchaîner sans casse. Notre outil analyse vos devis et vous restitue un planning ordonné, avec dépendances et chemin critique, en moins d'une minute.",
    benefits: [
      { title: "Adapté aux petits chantiers", text: "20 à 40 tâches typiques, échelle jour ou semaine. Pas de sur-planning inutile." },
      { title: "Anticipe les délais fournisseurs", text: "Menuiseries sur mesure, sanitaires : les délais d'appro sont intégrés automatiquement." },
      { title: "Gère l'immeuble occupé", text: "Contraintes d'accès et horaires respectées. Coactivité optimisée pour limiter la gêne." },
    ],
    steps: [
      "Décrivez la rénovation (surface, type, contraintes)",
      "Déposez les devis des entreprises",
      "Recevez le planning avec chemin critique",
    ],
    faq: [
      {
        q: "Quel est le délai moyen d'une rénovation d'appartement 70 m² ?",
        a: "Comptez 8 à 14 semaines selon l'ampleur des travaux. Une rénovation complète cuisine + sdb + peintures + parquet demande environ 10 semaines. Notre outil vous donne une durée précise en fonction de votre projet.",
      },
      {
        q: "L'outil fonctionne-t-il pour une rénovation lourde (démolition, murs porteurs) ?",
        a: "Oui. Ajoutez les devis structure et béton armé — les tâches lourdes sont intégrées comme des chantiers neufs (fondations renforts, dalles, IPN) avec les délais de séchage adaptés.",
      },
      {
        q: "Peut-on modifier le planning après génération ?",
        a: "Oui. L'interface permet de glisser les barres pour ajuster les dates, tirer le bord pour changer la durée, et enregistrer. Le chemin critique est recalculé automatiquement.",
      },
    ],
  },
  {
    slug: "planning-construction-maison",
    h1: "Planning de construction maison individuelle",
    metaTitle: "Planning construction maison — Généré par IA, gratuit",
    metaDescription:
      "Planning complet de construction de maison individuelle : gros œuvre, charpente, couverture, corps d'état second œuvre. Chemin critique identifié.",
    keywords: "planning construction maison, planning maison individuelle, planning MOB, planning béton, planning constructeur",
    heroPunch: "Du terrassement à la remise des clés, votre planning maître de A à Z.",
    intro:
      "Une construction neuve mobilise 10 à 15 corps d'état sur 8 à 14 mois. Un planning fiable est la seule garantie de tenir la date de livraison. Notre outil génère votre planning à partir des devis constructeur, artisans ou du CCTP.",
    benefits: [
      { title: "Adapté maison ossature bois ou béton", text: "Les durées et enchaînements sont ajustés selon le type de construction déclaré." },
      { title: "Intègre les délais réglementaires", text: "PC, DAACT, CONSUEL : les jalons administratifs sont positionnés en amont des tâches concernées." },
      { title: "Chemin critique visible", text: "Identifiez immédiatement quelles tâches ne peuvent pas glisser d'un jour." },
    ],
    steps: [
      "Renseignez le projet (surface, RT/RE, terrain)",
      "Ajoutez les devis constructeur ou par lot",
      "Obtenez le planning maître exportable",
    ],
    faq: [
      {
        q: "Combien de temps pour construire une maison de 120 m² ?",
        a: "En moyenne 10 à 14 mois : 4 mois de gros œuvre, 2 mois de mise hors d'air, 4 à 6 mois de second œuvre et finitions. La durée exacte dépend du type de construction et du contexte régional.",
      },
      {
        q: "Le planning tient-il compte des intempéries ?",
        a: "Nous ajoutons systématiquement 10 à 15 % de marge sur les phases sensibles (terrassement, gros œuvre, couverture) pour couvrir les intempéries courantes.",
      },
      {
        q: "Puis-je partager le planning avec mon banquier / assureur ?",
        a: "Oui. Exportez-le en PDF avec la synthèse et le tableau des tâches détaillé — format professionnel accepté par les organismes financiers.",
      },
    ],
  },
  {
    slug: "planning-btp-tertiaire",
    h1: "Planning BTP tertiaire : bureaux, commerces, aménagement",
    metaTitle: "Planning chantier tertiaire (bureaux, commerces) — Gratuit",
    metaDescription:
      "Planning de chantier tertiaire : aménagement bureaux, commerces, espaces professionnels. Coactivité optimisée, contraintes site en activité intégrées.",
    keywords: "planning chantier tertiaire, planning aménagement bureaux, planning commerce, planning open space, planning restaurant",
    heroPunch: "Bureaux, commerces, espaces recevant du public : votre planning en quelques secondes.",
    intro:
      "Un chantier tertiaire, c'est de la coactivité intense sur des délais serrés, souvent en site occupé. Notre outil sépare intelligemment les tâches bruyantes (à faire hors horaires) des tâches silencieuses.",
    benefits: [
      { title: "Site occupé / travaux de nuit", text: "Les contraintes de nuisance sont prises en compte. Les tâches bruyantes sont regroupées sur les créneaux autorisés." },
      { title: "Coactivité maximale", text: "Plusieurs corps d'état travaillent en parallèle quand c'est possible, pour raccourcir la durée." },
      { title: "Livraison par phases", text: "Idéal pour livrer un plateau après l'autre, en gardant une continuité d'activité." },
    ],
    steps: [
      "Décrivez l'espace à aménager (surface, cloisons, réseaux)",
      "Chargez les devis techniques (VDI, CVC, cloisons)",
      "Récupérez le planning avec phasage optimisé",
    ],
    faq: [
      {
        q: "Combien de temps pour aménager 500 m² de bureaux ?",
        a: "Comptez 8 à 12 semaines : 2 semaines de préparation et démolition, 4 à 6 semaines de cloisons + réseaux, 2 à 3 semaines de finitions et raccordements. Notre outil affine cette estimation selon vos spécificités.",
      },
      {
        q: "Le planning intègre-t-il les autorisations administratives (ERP, sécurité) ?",
        a: "Oui, les jalons DP, PC ou autorisation ERP sont positionnés en amont. Les dossiers commission de sécurité pour les ERP sont anticipés dans le planning.",
      },
      {
        q: "Peut-on faire un planning pour un restaurant / commerce ?",
        a: "Absolument. Ajoutez les spécificités (VMC restauration, extraction, sols alimentaires) dans la description — l'IA adapte le planning aux normes du secteur.",
      },
    ],
  },
];

export const findUseCase = (slug) => USE_CASES.find((u) => u.slug === slug);
